import { render } from "./FieldsTab.vue?vue&type=template&id=71539c8e"
import script from "./FieldsTab.vue?vue&type=script&lang=js"
export * from "./FieldsTab.vue?vue&type=script&lang=js"
script.render = render

export default script